import React, { useState, useEffect } from "react";
import useJWT from "../hooks/useJWT";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import useAddress from "../hooks/useAddress";
import Swal from "sweetalert2";

const schema = yup
  .object({
    name: yup.string().required(),
  })
  .required();

const AddNewAddress = ({ addressId, onFinish, colors = {} }) => {
  const { user } = useJWT();

  const {
    fetchSingleAddress,
    addAddress,
    updateAddress,
    single,
    addStatus,
    error,
    resetStatus,
  } = useAddress();

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (addressId !== null) {
      // Fetch single address if addressId is provided
      fetchSingleAddress(addressId);
    }
  }, [addressId]);

  useEffect(() => {
    if (single) {
      reset(single);
    }
  }, [single]);

  useEffect(() => {
    if (addStatus === "done") {
      Swal.fire({
        title: "Success",
        text: "Address updated successfully",
        icon: "success",
      });

      resetStatus();
      reset();
      onFinish && onFinish();
    } else if (addStatus === "error") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error || "Something went wrong while update address",
      });
      resetStatus();
    }
  }, [addStatus, user]);

  const onSubmit = async (data) => {
    const address = {
      ...data,
      userId: user?.id,
      isPrimary: data.isPrimary || false,
      isReturnAddress: data.isReturnAddress || false,
    };

    if (single?.id) {
      // Update existing address
      await updateAddress({ ...address, id: single.id });
    } else {
      // Create new address
      await addAddress(address);
    }
  };

  return (
    <section className="checkout py-80 dynamic-theme-add-address">
      <style>
        {`
          .dynamic-theme-add-address .btn-main-one { background-color: ${colors.categoryActive || '#2563EB'} !important; border-color: ${colors.categoryActive || '#2563EB'} !important; color: #fff !important; }
          .dynamic-theme-add-address .btn-main-one:hover { opacity: 0.9; }
          .dynamic-theme-add-address .form-check-input:checked { background-color: ${colors.categoryActive || '#2563EB'} !important; border-color: ${colors.categoryActive || '#2563EB'} !important; }
        `}
      </style>
      <div className="container container-md">
        <h6 className="text-xl mb-24">Address</h6>
        <form onSubmit={handleSubmit(onSubmit)} className="pe-xl-5">
          <div className="row gy-3">
            <div className="col-sm-6 col-xs-6">
              <input
                type="text"
                className="common-input border-gray-100"
                placeholder="Full Name"
                {...register("name")}
              />
              {errors.name && (
                <span className="text-danger">{errors.name.message}</span>
              )}
            </div>
            <div className="col-sm-6 col-xs-6">
              <input
                type="text"
                className="common-input border-gray-100"
                placeholder="Phone Number"
                {...register("phoneNumber")}
              />
            </div>
            <div className="col-sm-6 col-xs-6">
              <input
                type="text"
                className="common-input border-gray-100"
                placeholder="HP Number"
                {...register("mobilePhoneNumber")}
              />
            </div>
            <div className="col-sm-6 col-xs-6">
              <input
                type="text"
                className="common-input border-gray-100"
                placeholder="Province, City, Pos Code"
                {...register("province")}
              />
            </div>
            <div className="col-sm-6 col-xs-6">
              <input
                type="text"
                className="common-input border-gray-100"
                placeholder="Street Name, Building, Home Number"
                {...register("streetName")}
              />
            </div>
            <div className="col-sm-6 col-xs-6">
              <input
                type="text"
                className="common-input border-gray-100"
                placeholder="Other Detail"
                {...register("otherDetail")}
              />
            </div>
            <div className="col-sm-6 col-xs-6">
              <div className="border border-gray-100 d-flex flex-between align-items-center rounded-8 px-30 py-20 mb-10 w-100">
                <span>Set as primary address</span>
                <div className="form-check common-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue=""
                    id="isprimary"
                    {...register("isPrimary")}
                    disabled={single?.id}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-xs-6">
              <div className="border border-gray-100 d-flex flex-between align-items-center rounded-8 px-30 py-20 mb-10 w-100">
                <span>Set as return address</span>
                <div className="form-check common-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue=""
                    id="isreturn"
                    {...register("isReturnAddress")}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex w-100 justify-content-center mt-40">
            <button className="btn btn-main-one">
              <i class="ph ph-floppy-disk"></i> Save Address
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default AddNewAddress;
